class UGCTabs extends HTMLElement {
    constructor() {
        super();

        this.videoComponent = this.querySelector('ui-video');
        this.videoElement = this.videoComponent?.querySelector('video');
        this.posterEl = this.videoComponent?.querySelector('[data-video-poster]');

        this.quoteEl = this.querySelector('[data-target-quote]');
        this.tagEl = this.querySelector('[data-target-tag]');
        this.descriptionEl = this.querySelector('[data-target-description]');

        this.buttons = this.querySelectorAll('button[data-video-src]');
        this.activeButton = null;

        this.observer = null;
        this.hasEmitted = false;
    }

    connectedCallback() {
        this.bindEvents();
        this.initObserver();
    }

    bindEvents() {
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
                if (button === this.activeButton) return;
                this.handleTabClick(button);
            });
        });
    }

    setActiveButton(button) {
        this.buttons.forEach(btn => {
            btn.disabled = false;
            btn.setAttribute('aria-pressed', 'false');
        });

        button.disabled = true;
        button.setAttribute('aria-pressed', 'true');
        this.activeButton = button;
    }

    handleTabClick(button) {
        if (!this.videoComponent || !this.videoElement) return;

        const src = button.dataset.videoSrc;
        const poster = button.dataset.poster;
        const quote = button.dataset.quote;
        const tag = button.dataset.tag;
        const description = button.dataset.description;

        const wasMuted = this.videoElement.muted;

        this.videoComponent.dataset.src = src;

        if (poster) {
            this.videoComponent.dataset.poster = poster;
            if (this.posterEl) this.posterEl.src = poster;
        }

        this.videoComponent.emitVideo();

        this.videoElement.currentTime = 0;
        this.videoElement.muted = wasMuted;
        this.videoComponent.updateMuteUI();
        this.videoComponent.play();

        if (this.quoteEl) this.quoteEl.textContent = quote || '';
        if (this.tagEl) this.tagEl.textContent = tag || '';
        if (this.descriptionEl) this.descriptionEl.textContent = description || '';

        this.setActiveButton(button);
    }

    initObserver() {
        if (!this.videoComponent) return;

        this.observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.hasEmitted) {
                        this.emitFirstVideo();
                        this.hasEmitted = true;
                        this.observer.disconnect();
                    }
                });
            },
            { threshold: 0.5 }
        );

        this.observer.observe(this.videoComponent);
    }

    emitFirstVideo() {
        if (!this.videoComponent || !this.videoElement) return;

        const defaultTab =
            this.querySelector('button[data-video-src][aria-pressed="true"]') ||
            this.buttons[0];
        if (!defaultTab) return;

        this.handleTabClick(defaultTab);
        this.videoElement.muted = true;
        this.videoComponent.updateMuteUI();
    }
}

customElements.define('ugc-tabs', UGCTabs);